import { Directive, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { Observable, fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export interface Viewport {
  width: number;
  height: number;
}

@Directive({
  selector: '[fixedHeader]'
})
export class FixedHeaderDirective implements AfterViewInit, OnDestroy {
  private el: any;
  private scrollEvent$: Observable<any>;
  private resizeEvent$: Observable<any>;
  private scrollSubscription: Subscription;
  private resizeSubscription: Subscription;
  private fixedHeaderClassName = 'fixed-table-header';
  @Input() parentContainerSelector = '.page-container';
  @Input() pageHeaderSelector = '.fixed-header .header';
  @Input() secondaryHeaderSelector = '.container-fixed-header';

  constructor(private element: ElementRef) {
    this.el = element.nativeElement;
  }

  ngAfterViewInit() {
    const container = <HTMLElement>document.querySelector(this.parentContainerSelector);
    const pageHeader = <HTMLElement>document.querySelector(this.pageHeaderSelector);
    const tableHeader = this.el.querySelector('.k-grid-header');

    this.resizeEvent$ = fromEvent(window, 'resize').pipe(debounceTime(100));
    this.scrollEvent$ = fromEvent(container, 'scroll').pipe(debounceTime(100));


    this.scrollSubscription = this.scrollEvent$.subscribe(() => {
      const gridRect = this.el.getBoundingClientRect();
      const gridContainer = this.el.querySelector('.k-grid-container');
      const toolbar = this.el.querySelector('.k-toolbar');
      const secondaryHeader = <HTMLElement>document.querySelector(this.secondaryHeaderSelector);
      const tableTop = gridRect.top + (toolbar?.clientHeight || 0);
      const headerBottomLine = Math.max(pageHeader.getBoundingClientRect().bottom, secondaryHeader.getBoundingClientRect().bottom);
      if (!this.el.offsetParent || tableTop >= headerBottomLine) {
        tableHeader.classList.remove(this.fixedHeaderClassName);
        tableHeader.style.width = 'auto';
        gridContainer.style.paddingTop = 0;
      } else if (tableTop < headerBottomLine && gridRect.bottom >= headerBottomLine) {
        gridContainer.style.paddingTop = tableHeader.clientHeight + 'px';
        tableHeader.classList.add(this.fixedHeaderClassName);
        tableHeader.style.width = this.el.clientWidth + 'px';
        tableHeader.style.top = headerBottomLine + 'px';
      }
    });

    this.resizeSubscription = this.resizeEvent$.subscribe(() => {
      const secondaryHeader = <HTMLElement>document.querySelector(this.secondaryHeaderSelector);
      const headerBottomLine = Math.max(pageHeader.getBoundingClientRect().bottom, secondaryHeader.getBoundingClientRect().bottom);
      if (tableHeader.classList.contains(this.fixedHeaderClassName)) {
        tableHeader.style.width = this.el.clientWidth + 'px';
        tableHeader.style.top = headerBottomLine + 'px';
      }
    });
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }
}
